import { AuthBaseState } from './auth-base.model';
import { Actions, ActionTypes } from './auth-base.action';

const initialState = new AuthBaseState();

export function reducer(
  state = initialState,
  action: Actions
): AuthBaseState {

  switch (action.type) {

    case ActionTypes.Authorize:
      return {
        ...state,
        userId: action.payload.userId,
        accessToken: action.payload.auth.accessToken,
        refreshToken: action.payload.auth.refreshToken,
        expiresIn: action.payload.auth.expiresIn,
        expiresAt: action.payload.auth.expiresAt,
        authorType: action.payload.auth.author
          ? action.payload.auth.author.authorType
          : 'CLIENT',
        cloudDnsRoleCode: action.payload.auth.author
          ? action.payload.auth.author.cloudDnsRoleCode
          : undefined,
        clientUserId: action.payload.clientId,
        authorized: true
      };

    case ActionTypes.SetActiveClient:
      return {
        ...state,
        clientUserId: action.payload
      };

    case ActionTypes.SetReferer:
      return {
        ...state,
        referer: action.payload
      };

    case ActionTypes.ResetReferer:
      return {
        ...state,
        referer: undefined
      };

    case ActionTypes.RefreshTokenLocalSuccess:
      return {
        ...state,
        accessToken: action.accessToken,
        refreshToken: action.refreshToken !== undefined ? action.refreshToken : state.refreshToken,
        expiresIn: action.expiresIn !== undefined ? action.expiresIn : state.expiresIn,
        expiresAt: action.expiresAt !== undefined ? action.expiresAt : state.expiresAt
      };

    // reset
    case ActionTypes.InvalidateAuthorization:
      return { ...initialState };

  }

  return state;
}
